module.exports = __webpack_public_path__ + "static/img/11.ee0449b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fgimg/11.jpg
// module id = YAEg
// module chunks = 18